import React from "react"
import { Box, CircularProgress, Stack, Typography } from "@mui/material"
import { PhotoLibraryOutlined } from "@mui/icons-material"

const LoadingGallery: React.FC = () => (
  <Stack alignItems="center" justifyContent="center" minHeight={400}>
    <CircularProgress />
  </Stack>
)

const EmptyGallery: React.FC = () => (
  <Stack alignItems="center" justifyContent="center" minHeight={400} gap={2}>
    <Box sx={{ color: "text.disabled", fontSize: 72, lineHeight: 1 }}>
      <PhotoLibraryOutlined fontSize="inherit" />
    </Box>
    <Typography variant="h6" color="text.secondary">
      No photos yet
    </Typography>
    <Typography variant="body2" color="text.disabled">
      Images generated by AI will appear here.
    </Typography>
  </Stack>
)

export { LoadingGallery, EmptyGallery }
